import axios from "axios";
import QueryString from "qs";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import RouteIcon from "../Icons/RouteIcon";
import EyeIcon from "../Icons/EyeIcon";
import { imageLoader } from "../../../../utils/imageLoader";

async function getProgrammeById(programmeId) {
  const singleProgramQuery = QueryString.stringify({
    fields: ["name", "address", "isRp"],
    populate: {
      images: {
        fields: ["id"],
        populate: {
          image: {
            fields: ["url"],
          },
        },
      },
      lots: {
        fields: ["id"],
        populate: {
          images: {
            fields: ["id"],
            populate: {
              image: {
                fields: ["url"],
              },
            },
          },
        },
      },
    },
  });

  const response = await axios.get(
    `${process.env.REACT_APP_ENDPOINT_URL}api/programmes/${programmeId}?${singleProgramQuery}`,
  );
  if (!response.data?.data) throw new Error("Failed to fetch programme");

  return response.data.data;
}

const getProgrammeImageUrl = (programme) => {
  const pImg = programme?.images?.find((el) => el?.image[0]?.url)?.image[0]
    ?.url;
  if (pImg) return imageLoader(pImg);
  const lotImage = programme.lots?.find(
    (el) => el?.images?.[0]?.image?.[0]?.url,
  )?.images?.[0]?.image?.[0]?.url;
  if (lotImage) return imageLoader(lotImage);
  return null;
};

export const ProgrammeInfoWindow = ({
  documentId,
  onSetPointA,
  onSetPointB,
  onViewMore,
  markerLat,
  markerLng,
}) => {
  const [programme, setProgramme] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await getProgrammeById(documentId);
        if (!cancelled) setProgramme(data);
      } catch (e) {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [documentId]);

  return (
    <div
      className="d-flex align-items-center hideScrollbar"
      style={{ width: 260, height: 380 }}
    >
      {loading ? (
        <div className="alignC flex-column gap-3 bold">
          <Spinner variant="orange" animation="grow" />
        </div>
      ) : error || !programme ? (
        <div
          className="text-center bold f12"
          style={{
            color: "#b91c1c",
          }}
        >
          Erreur lors du chargement du programme. <br /> Veuillez rafraîchir la
          page.
        </div>
      ) : (
        <div className="d-flex flex-column justify-content-between h100 w100 hideScrollbar">
          <img
            src={getProgrammeImageUrl(programme) ?? "./assets/imgNotFound.webp"}
            alt={programme.name}
            style={{
              width: "100%",
              height: 180,
              objectFit: "contain",
              borderRadius: 10,
              marginBottom: 10,
              background: "#f3f4f6",
              display: "block",
            }}
            loading="lazy"
          />
          <hr />
          <div className="d-flex flex-column gap-2">
            <div className="bold f14">{programme.name}</div>
            <div className="f12 alignH">
              <img
                src="./icons/icon_location_grey.svg"
                width={16}
                height={16}
                alt="Localisation"
              />
              {programme.address}
            </div>
            <div className="f12">{`${
              programme.lots?.length
                ? `${programme.lots?.length} lot(s)`
                : "Aucun lot disponible"
            }`}</div>
          </div>
          <hr />
          <div className="alignH gap-1">
            <button
              type="button"
              className={`${programme.isRp ? "pink1" : "blue1"} radius10 flex-1`}
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                height: 40,
                textDecoration: "none",
                fontWeight: 600,
                fontSize: 14,
                border: "none",
              }}
              onClick={() => onViewMore?.(documentId)}
            >
              <EyeIcon />
            </button>
            <button
              style={{
                alignItems: "center",
                justifyContent: "center",
                height: 40,
                textDecoration: "none",
                fontWeight: 600,
                fontSize: 14,
              }}
              className={`bg-white w30 ${
                programme.isRp ? "pink2" : "blue2"
              } radius10 px-3`}
              onClick={() =>
                onSetPointB?.({
                  latLng: new window.google.maps.LatLng(markerLat, markerLng),
                  label: programme?.name || "Programme",
                })
              }
            >
              <RouteIcon />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
